/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AttachmentUploadedType = 'CONTRACT' | 'NOTICE' | 'OTHERS' | 'LINK' | 'UPLOADED';

export const AttachmentUploadedType = {
    CONTRACT: 'CONTRACT' as AttachmentUploadedType,
    NOTICE: 'NOTICE' as AttachmentUploadedType,
    OTHERS: 'OTHERS' as AttachmentUploadedType,
    LINK: 'LINK' as AttachmentUploadedType,
    UPLOADED: 'UPLOADED' as AttachmentUploadedType
};

